import { GenderTypeEnum } from "app/back-office/shared/enum/gender-type.enum.model";

export class SizesMapper {
  public sizesItems: SizesMapperItem[];

  constructor() {
    this.sizesItems = [
      {
        styleGroupId: 260, //pants
        gender: GenderTypeEnum.Man,
        sizes: [
          { sizeName: 'S', newSizeName: 'S/44' },
          { sizeName: 'M', newSizeName: 'M/46' },
          { sizeName: 'L', newSizeName: 'L/48' },
          { sizeName: 'XL', newSizeName: 'XL/50' },
          { sizeName: 'XXL', newSizeName: '2XL/52' },
          { sizeName: 'XXXL', newSizeName: '3XL/54' },
          { sizeName: 'XXXXL', newSizeName: '4XL/56' },
        ]
      },
      {
        styleGroupId: 260, //pants
        gender: GenderTypeEnum.Woman,
        sizes: [
          { sizeName: 'XS', newSizeName: 'XS/38' },
          { sizeName: 'S', newSizeName: 'S/40' },
          { sizeName: 'M', newSizeName: 'M/42' },
          { sizeName: 'L', newSizeName: 'L/44' },
          { sizeName: 'XL', newSizeName: 'XL/46' },
          { sizeName: '2XL', newSizeName: '2XL/48' },
          { sizeName: '3XL', newSizeName: '3XL/50' },
        ]
      }
    ]
  }
}

export class SizesMapperItem {
  public styleGroupId: number;
  public gender: GenderTypeEnum;
  public sizes: SizesMapperItemValue[];
}
export class SizesMapperItemValue {
  public sizeName: string;
  public newSizeName: string;
}